import { StyleSheet, Platform, Linking, Image } from "react-native";
import { View, Text } from "../../components/Themed";
import Colors from "../../constants/Colors";
import Pressable from "../../components/Pressable";
import { useEffect } from "react";
import scheme from "../../app.config";

export default function DownloadPrompt() {
  useEffect(() => {
    if (Platform.OS === "web") {
      const hasAttemptedRedirect = sessionStorage.getItem(
        "hasAttemptedRedirect"
      );
      if (!hasAttemptedRedirect) {
        sessionStorage.setItem("hasAttemptedRedirect", "true");
        handleDownload();
      }
    }
  }, []);

  const getMobileOperatingSystem = () => {
    const userAgent = window.navigator.userAgent || window.navigator.vendor;

    if (/android/i.test(userAgent)) {
      return "android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return "ios";
    }

    return "unknown";
  };

  const getBrowserInfo = () => {
    const userAgent = window.navigator.userAgent;
    const isIOS =
      /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;

    if (!isIOS) return { browser: "unknown", isIOS: false };

    if (/CriOS/.test(userAgent)) return { browser: "chrome", isIOS: true };
    if (/FxiOS/.test(userAgent)) return { browser: "firefox", isIOS: true };
    if (/EdgiOS/.test(userAgent)) return { browser: "edge", isIOS: true };
    if (
      /Safari/.test(userAgent) &&
      !/Chrome|CriOS|FxiOS|EdgiOS/.test(userAgent)
    ) {
      return { browser: "safari", isIOS: true };
    }

    return { browser: "unknown", isIOS: true };
  };

  const appScheme = scheme.expo.scheme + "://";
  const iosLink = "https://apps.apple.com/app/6504693832";
  const androidLink =
    "https://play.google.com/store/apps/details?id=com.brivity.openhouse";
  const deviceType = getMobileOperatingSystem();

  const getUniversalLink = () => {
    if (typeof window !== "undefined" && window.location?.origin) {
      return window.location.origin;
    }
    const isDev = process.env.NODE_ENV === "development";
    return isDev
      ? "https://openhouse.staging.brivity.com"
      : "https://openhouse.brivity.com";
  };

  const handleDownload = () => {
    if (Platform.OS === "web") {
      const storeLink = deviceType === "ios" ? iosLink : androidLink;
      const universalLink = getUniversalLink();
      const browserInfo = getBrowserInfo();

      if (browserInfo.isIOS) {
        if (browserInfo.browser === "safari") {
          let appOpened = false;
          let hasRedirected = false;
          let startTime = Date.now();

          const cleanup = () => {
            document.removeEventListener(
              "visibilitychange",
              handleVisibilityChange
            );
            window.removeEventListener("pagehide", handlePageHide);
          };

          const handleVisibilityChange = () => {
            const timeDiff = Date.now() - startTime;
            if (document.hidden && timeDiff > 500 && !hasRedirected) {
              appOpened = true;
              hasRedirected = true;
              cleanup();
            }
          };

          const handlePageHide = () => {
            const timeDiff = Date.now() - startTime;
            if (timeDiff > 500 && !hasRedirected) {
              appOpened = true;
              hasRedirected = true;
              cleanup();
            }
          };

          document.addEventListener("visibilitychange", handleVisibilityChange);
          window.addEventListener("pagehide", handlePageHide);

          try {
            window.location.href = appScheme;

            setTimeout(() => {
              if (!appOpened && !hasRedirected) {
                hasRedirected = true;
                cleanup();
                window.location.replace(storeLink);
              }
            }, 2500);
          } catch (error) {
            cleanup();
            window.location.replace(storeLink);
          }
        } else if (browserInfo.browser === "chrome") {
          let appOpened = false;
          let hasRedirected = false;
          let attemptCount = 0;

          const cleanup = () => {
            document.removeEventListener(
              "visibilitychange",
              handleVisibilityChange
            );
            window.removeEventListener("blur", handleBlur);
            if (!hasRedirected) {
            }
          };

          const handleVisibilityChange = () => {
            if (document.hidden && !hasRedirected) {
              appOpened = true;
              hasRedirected = true;
              cleanup();
            }
          };

          const handleBlur = () => {
            if (!hasRedirected) {
              appOpened = true;
              hasRedirected = true;
              cleanup();
            }
          };

          document.addEventListener("visibilitychange", handleVisibilityChange);
          window.addEventListener("blur", handleBlur);

          const tryAppOpen = () => {
            attemptCount++;

            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.style.width = "1px";
            iframe.style.height = "1px";
            iframe.src = `${appScheme}`;
            document.body.appendChild(iframe);

            setTimeout(() => {
              if (document.body.contains(iframe)) {
                document.body.removeChild(iframe);
              }
            }, 1000);

            setTimeout(() => {
              if (!appOpened && !hasRedirected) {
                hasRedirected = true;
                cleanup();
                window.location.href = storeLink;
              }
            }, 2500);
          };

          tryAppOpen();
        } else {
          let appOpened = false;
          let hasRedirected = false;

          const cleanup = () => {
            document.removeEventListener(
              "visibilitychange",
              handleVisibilityChange
            );
            window.removeEventListener("blur", handleBlur);
            window.removeEventListener("pagehide", handlePageHide);
            if (!hasRedirected) {
            }
          };

          const handleVisibilityChange = () => {
            if (document.hidden && !hasRedirected) {
              appOpened = true;
              hasRedirected = true;
              cleanup();
            }
          };

          const handleBlur = () => {
            if (!hasRedirected) {
              appOpened = true;
              hasRedirected = true;
              cleanup();
            }
          };

          const handlePageHide = () => {
            if (!hasRedirected) {
              appOpened = true;
              hasRedirected = true;
              cleanup();
            }
          };

          document.addEventListener("visibilitychange", handleVisibilityChange);
          window.addEventListener("blur", handleBlur);
          window.addEventListener("pagehide", handlePageHide);

          try {
            window.location.href = appScheme;

            setTimeout(() => {
              if (!appOpened && !hasRedirected) {
                hasRedirected = true;
                cleanup();
                window.location.href = storeLink;
              }
            }, 2000);
          } catch (error) {
            cleanup();
            window.location.href = storeLink;
          }
        }
      } else {
        window.location.href = appScheme;
        setTimeout(() => {
          window.location.href = storeLink;
        }, 2500);
      }
    } else {
      Linking.canOpenURL(appScheme)
        .then((supported) => {
          if (supported) {
            Linking.openURL(`${appScheme}`);
          } else {
            const storeLink = deviceType === "ios" ? iosLink : androidLink;
            Linking.openURL(storeLink);
          }
        })
        .catch((error) => {
          const storeLink = deviceType === "ios" ? iosLink : androidLink;
          Linking.openURL(storeLink);
        });
    }
  };

  useEffect(() => {
    const subscription = Linking.addEventListener("url", ({ url }) => {
      url && handleDeepLink(url);
    });

    Linking.getInitialURL()
      .then((url) => {
        url && handleDeepLink(url);
      })
      .catch(console.warn);

    return () => {
      if (subscription && typeof subscription.remove === "function") {
        subscription.remove();
      }
    };
  }, []);

  const handleDeepLink = (url: string) => {
    const blossorId = url
      ?.split("/")
      ?.find((segment) => segment.startsWith("bid-"))
      ?.split("-")
      ?.slice(1, 3)
      ?.join("-");

    if (blossorId) {
      if (Platform.OS === "web") {
        const universalLink = `${getUniversalLink()}/bid-${blossorId}`;
        const storeLink = deviceType === "ios" ? iosLink : androidLink;

        const browserInfo = getBrowserInfo();

        if (browserInfo.isIOS) {
          if (browserInfo.browser === "safari") {
            let appOpened = false;
            let hasRedirected = false;
            let startTime = Date.now();

            const cleanup = () => {
              document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange
              );
              document.removeEventListener("pagehide", handlePageHide);
            };

            const handleVisibilityChange = () => {
              const timeDiff = Date.now() - startTime;
              if (document.hidden && timeDiff > 500 && !hasRedirected) {
                appOpened = true;
                hasRedirected = true;
                cleanup();
              }
            };

            const handlePageHide = () => {
              const timeDiff = Date.now() - startTime;
              if (timeDiff > 500 && !hasRedirected) {
                appOpened = true;
                hasRedirected = true;
                cleanup();
              }
            };

            document.addEventListener(
              "visibilitychange",
              handleVisibilityChange
            );
            document.addEventListener("pagehide", handlePageHide);

            try {
              window.location.href = `${appScheme}bid-${blossorId}`;

              setTimeout(() => {
                if (!appOpened && !hasRedirected) {
                  hasRedirected = true;
                  cleanup();
                  window.location.replace(storeLink);
                }
              }, 2500);
            } catch (error) {
              cleanup();
              window.location.replace(storeLink);
            }
          } else if (browserInfo.browser === "chrome") {
            let appOpened = false;
            let hasRedirected = false;
            let attemptCount = 0;

            const cleanup = () => {
              document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange
              );
              window.removeEventListener("blur", handleBlur);
            };

            const handleVisibilityChange = () => {
              if (document.hidden && !hasRedirected) {
                appOpened = true;
                hasRedirected = true;
                cleanup();
              }
            };

            const handleBlur = () => {
              if (!hasRedirected) {
                appOpened = true;
                hasRedirected = true;
                cleanup();
              }
            };

            document.addEventListener(
              "visibilitychange",
              handleVisibilityChange
            );
            document.addEventListener("blur", handleBlur);

            const tryDeepLink = () => {
              attemptCount++;

              const iframe = document.createElement("iframe");
              iframe.style.display = "none";
              iframe.style.width = "1px";
              iframe.style.height = "1px";
              iframe.src = `${appScheme}bid-${blossorId}`;
              document.body.appendChild(iframe);

              setTimeout(() => {
                if (document.body.contains(iframe)) {
                  document.body.removeChild(iframe);
                }
              }, 1000);

              setTimeout(() => {
                if (!appOpened && !hasRedirected) {
                  hasRedirected = true;
                  cleanup();
                  window.location.href = storeLink;
                }
              }, 2500);
            };

            tryDeepLink();
          } else {
            let appOpened = false;
            let hasRedirected = false;

            const cleanup = () => {
              document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange
              );
              window.removeEventListener("blur", handleBlur);
              window.removeEventListener("pagehide", handlePageHide);
            };

            const handleVisibilityChange = () => {
              if (document.hidden && !hasRedirected) {
                appOpened = true;
                hasRedirected = true;
                cleanup();
              }
            };

            const handleBlur = () => {
              if (!hasRedirected) {
                appOpened = true;
                hasRedirected = true;
                cleanup();
              }
            };

            const handlePageHide = () => {
              if (!hasRedirected) {
                appOpened = true;
                hasRedirected = true;
                cleanup();
              }
            };

            document.addEventListener(
              "visibilitychange",
              handleVisibilityChange
            );
            window.addEventListener("blur", handleBlur);
            document.addEventListener("pagehide", handlePageHide);

            try {
              window.location.href = `${appScheme}bid-${blossorId}`;

              setTimeout(() => {
                if (!appOpened && !hasRedirected) {
                  hasRedirected = true;
                  cleanup();
                  window.location.href = storeLink;
                }
              }, 2000);
            } catch (error) {
              cleanup();
              window.location.href = storeLink;
            }
          }
        } else {
          window.location.href = `${appScheme}bid-${blossorId}`;
          setTimeout(() => {
            window.location.href = storeLink;
          }, 2500);
        }
      } else {
        Linking.canOpenURL(appScheme)
          .then((supported) => {
            if (supported) {
              Linking.openURL(`${appScheme}/bid-${blossorId}`);
            } else {
              const storeLink = deviceType === "ios" ? iosLink : androidLink;
              Linking.openURL(storeLink);
            }
          })
          .catch((err) => {
            const storeLink = deviceType === "ios" ? iosLink : androidLink;
            Linking.openURL(storeLink);
          });
      }
    }
  };

  return (
    <View style={styles.container}>
      <Image
        resizeMode="contain"
        source={require("../../assets/brivity.png")}
        style={{ height: "45%", width: "45%", maxHeight: 200, maxWidth: 200 }}
      />
      <View style={styles.content}>
        <Text
          size={24}
          weight="Bold"
          style={styles.title}
          lightColor={Colors.nuetral_grey_700}
        >
          Mobile Browser Not Supported
        </Text>

        <Text
          size={16}
          style={styles.message}
          lightColor={Colors.nuetral_grey_700}
        >
          Please download our mobile app for the best experience on your device.
        </Text>

        <Pressable
          style={({ pressed }) => [
            styles.button,
            pressed && styles.buttonPressed,
          ]}
          onPress={handleDownload}
        >
          <Text size={16} weight="Bold" style={styles.buttonText}>
            Download App
          </Text>
        </Pressable>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.base_colors_white,
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  content: {
    width: "100%",
    maxWidth: 400,
    alignItems: "center",
    marginTop: 20,
  },
  title: {
    textAlign: "center",
    marginBottom: 16,
  },
  message: {
    textAlign: "center",
    marginBottom: 32,
  },
  button: {
    backgroundColor: Colors.primary_500,
    maxWidth: 300,
    borderRadius: 10,
    paddingVertical: 5,
    paddingHorizontal: 20,
  },
  buttonPressed: {
    opacity: 0.5,
  },
  buttonText: {
    color: Colors.base_colors_white,
    textAlign: "center",
    padding: 10,
  },
});
